module.exports = __webpack_public_path__ + "34c8b9f97c75ddb26001659ac813815d.png";